import { apiClient } from "@base/api/client";
import type { MemberProfile } from "@features/admin/model/types";

export async function fetchMemberProfile(userId: number): Promise<MemberProfile> {
  const { data } = await apiClient.get<MemberProfile>(`/82office/membership/api/admin/users/${userId}/profile`);
  return data;
}
